import { getEnvironmentId } from '../app/js/utils/getEnvironmentId';

declare const HJ_REVISION: string;

import { datadogRum } from '@datadog/browser-rum';
let sampleRate = 100;

if (getEnvironmentId() === 'live') {
    sampleRate = 10;
}

const clientToken = 'pub0556aa817da326ee37e8b68ec5c0876b',
    applicationId = '0064c4cd-7098-44b1-8d5e-69c67e138235',
    isScreenshotMode = Boolean(new URLSearchParams(window.location.search).get('forScreenshot')),
    isRetakerMode = Boolean(new URLSearchParams(window.location.search).get('forRetaker'));

const environmentId = getEnvironmentId();

if (environmentId !== 'dev' && !isScreenshotMode && !isRetakerMode) {
    datadogRum.init({
        applicationId: applicationId,
        clientToken: clientToken,
        site: 'datadoghq.eu',
        env: getEnvironmentId(),
        version: HJ_REVISION,
        service: 'Playback',
        sampleRate: sampleRate,
        allowedTracingOrigins: [/https:\/\/.*\.hotjar\.com/, /https:\/\/.*\.hotjar\.io/]
    });

    window.datadogRum = datadogRum;
}
